// extracted by mini-css-extract-plugin
module.exports = {"w1lgshfa":"w1lgshfa","ck529d4":"ck529d4"};